import React from 'react';
import './../../css/style.css';
import axios from './../../../axios';
import Moment from "moment";
import FileListComponent from '../../../components/FundFiles/index.js'
import { handleNav } from '../../../util/index.js';
// // 基金文件组件
// class FundFiles extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       showAll: false,
//       visibleCount: 5
//     };
//   }

//   handleViewMore = () => {
//     this.setState({ showAll: true });
//   }

//   render() {
//     const { files, title } = this.props;
//     const { showAll, visibleCount } = this.state;

//     if (!files || files.length === 0) {
//       return null;
//     }

//     const displayFiles = showAll ? files : files.slice(0, visibleCount);
//     const hasMore = files.length > visibleCount && !showAll;

//     return (
//       <div className="fund-files-section">
//         <h2>{title}</h2>
//         <table className="dltable">
//           <tbody>
//             {displayFiles.map((file, index) => (
//               <tr key={index}>
//                 <td style={{width: '5%'}}>
//                   <img alt="" src="./images/download.gif" width="21" height="25"/>
//                 </td>
//                 <td width="20%">{file.PUBLISH_DATE.slice(0,10)}</td>
//                 <td colSpan="2">
//                   <a href={`/active-service/HK-BOCIM/download/${file.ID}`} target="_blank">
//                     {file.PUBLISH_NAME}
//                   </a>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//         {hasMore && (
//           <div className="view-more-container">
//             <button className="view-more-btn" onClick={this.handleViewMore}>
//               查看更多
//             </button>
//           </div>
//         )}
//       </div>
//     );
//   }
// }

// 基金公告组件
class FundNotices extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showAll: false,
            visibleCount: 5
        };
    }

    handleViewMore = () => {
        this.setState({ showAll: true });
    }

    render() {
        const { notices, title } = this.props;
        const { showAll, visibleCount } = this.state;

        if (!notices || notices.length === 0) {
            return null;
        }

        const displayNotices = showAll ? notices : notices.slice(0, visibleCount);
        const hasMore = notices.length > visibleCount && !showAll;

        return (
            <div className="fund-notices-section">
                <h2>{title}</h2>
                <table className="dltable">
                    <tbody>
                        {displayNotices.map((notice, index) => (
                            <tr key={index}>
                                <td style={{ width: '5%' }}>
                                    <img alt="" src="./images/download.gif" width="21" height="25" />
                                </td>
                                <td width="20%">{notice.PUBLISH_DATE.slice(0, 10)}</td>
                                <td colSpan="2">
                                    <a href={`/active-service/HK-BOCIM/download/${notice.ID}`} target="_blank">
                                        {notice.PUBLISH_NAME}
                                    </a>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                {hasMore && (
                    <div className="view-more-container">
                        <button className="view-more-btn" onClick={this.handleViewMore}>
                            查看更多
                        </button>
                    </div>
                )}
            </div>
        );
    }
}

// 下载组件
class Downloads extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showAll: false,
            visibleCount: 5
        };
    }

    handleViewMore = () => {
        this.setState({ showAll: true });
    }

    render() {
        const { downloads, title } = this.props;
        const { showAll, visibleCount } = this.state;

        if (!downloads || downloads.length === 0) {
            return null;
        }

        const displayDownloads = showAll ? downloads : downloads.slice(0, visibleCount);
        const hasMore = downloads.length > visibleCount && !showAll;

        return (
            <div className="downloads-section">
                <h2>{title}</h2>
                <table className="dltable">
                    <tbody>
                        {displayDownloads.map((download, index) => (
                            <tr key={index}>
                                <td style={{ width: '5%' }}>
                                    <img alt="" src="./images/download.gif" width="21" height="25" />
                                </td>
                                <td colSpan="2">
                                    <a href={`/active-service/HK-BOCIM/download/${download.ID}`} target="_blank">
                                        {download.PUBLISH_NAME}
                                    </a>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                {hasMore && (
                    <div className="view-more-container">
                        <button className="view-more-btn" onClick={this.handleViewMore}>
                            查看更多
                        </button>
                    </div>
                )}
            </div>
        );
    }
}

// 主组件
export default class GaoxiFunds extends React.Component {
    constructor(props) {
        super(props);
        document.title = '中银香港资产管理有限公司';
        this.params = {};
        this.state = {
            downloads: [],      // 下载数据数组
            fundFiles: [],      // 基金文件数据数组
            fundNotices: [],    // 基金公告数据数组
            noticeList: [],
            fundvaluelist: [],
            performanceTime: [],
            performanceValue: [],
            saleOrgs: []        // 销售机构数据
        };

        this.requestListTest();
        this.requestListPerformance();
        this.requestSaleOrg();
    }

    // 请求销售机构数据
    requestSaleOrg = () => {
        axios.ajaxAESETF({
            url: '/aresoft-api/api/fundinfo/getFundInfoAgencyRelation',
            data: {
                params: {
                    fundCode: '968012',
                }
            }
        }).then(res => {
            console.log(res, 'saleOrg')
            if (res.code === '0000' && res.data && res.data.length > 0) {
                // 按AGENT_CODE排序，确保顺序一致
                const sortedSaleOrgs = res.data.sort((a, b) => {
                    return parseInt(a.AGENT_CODE) - parseInt(b.AGENT_CODE);
                });

                this.setState({
                    saleOrgs: sortedSaleOrgs
                });
            }
        }).catch(error => {
            console.error('获取销售机构数据失败:', error);
        });
    }

    requestListPerformance = () => {
        axios.ajaxAESETF({
            url: '/aresoft-api/api/getHKPerformanceList',
            data: {
                params: {
                    fundCode: '968012',
                    pageIndex: '1',
                    pageSize: '100'
                }
            }
        }).then((res) => {
            this.setState({
                performanceTime: res.data.map((item) => (
                    <td width="8%" key={item.PUBLISH_TIME}>{item.PUBLISH_TIME}</td>
                )),
                performanceValue: res.data.map((item) => (
                    <td width="8%" key={item.PUBLISH_TIME}>{item.PUBLISH_PERFORMANCE}</td>
                ))
            });
        });
    }

    requestListTest = () => {
        // 获取基金净值
        axios.ajaxAESETF({
            url: '/aresoft-api/api/getLatestHKValue',
            data: {
                params: {
                    fundcode: '968012',
                }
            }
        }).then((res) => {
            this.setState({
                fundvaluelist: handleNav(res.data)
              });
            // this.setState({
            //     fundvaluelist: res.data.map((item, index) => (
            //         <tr key={index}>
            //             <td>{item.UPDATEDATE}</td>
            //             <td>人民币</td>
            //             <td colSpan="4">{item.NAV}</td>
            //         </tr>
            //     ))
            // });
        });

        // 获取文件列表
        axios.ajaxAESETF({
            url: '/aresoft-api/api/getHKFileList',
            data: {
                params: {
                    fundcode: '968012',
                    pageIndex: '1',
                    pageSize: '1000',
                    status: '1',
                    publishdate: Moment().format('YYYY-MM-DD HH:mm:ss')
                }
            }
        }).then((res) => {
            // 直接分类数据，不再需要在state中存储渲染的JSX
            const downloads = res.data.filter(item => item.FILE_TYPE === '下载');
            const fundFiles = res.data.filter(item => item.FILE_TYPE === '基金文件');
            const fundNotices = res.data.filter(item => item.FILE_TYPE === '基金公告');

            this.setState({
                downloads,
                fundFiles,
                fundNotices
            });
        });
    }

    toTheTop = () => {
        document.documentElement.scrollTop = document.body.scrollTop = 0;
    }

    // 渲染销售机构列表
    renderSaleOrgs = () => {
        const { saleOrgs } = this.state;

        if (!saleOrgs || saleOrgs.length === 0) {
            // 如果API没有返回数据，return null（按您的要求）
            return null;
        }

        if (saleOrgs.length === 1) {
            // 只有一个销售机构时，直接返回名称
            return saleOrgs[0].AGENT_NAME;
        } else if (saleOrgs.length === 2) {
            // 两个销售机构时，用"和"连接
            return `${saleOrgs[0].AGENT_NAME}和${saleOrgs[1].AGENT_NAME}`;
        } else {
            // 三个及以上销售机构时，前n-1个用顿号连接，最后一个用"和"连接
            const names = saleOrgs.map(org => org.AGENT_NAME);
            const lastItem = names.pop(); // 移除最后一个元素
            return `${names.join('、')}和${lastItem}`;
        }
    }

    render() {
        return (
            <div className="wrapper">
                <div className="main-container">
                    <table>
                        <tbody>
                            <tr>
                                <td width="12%">&nbsp;</td>
                                <td className="main-content">
                                    <table width="100%">
                                        <tbody>
                                            <tr>
                                                <td width="40%">内地代理人：</td>
                                                <td width="60%">基金管理人：</td>
                                            </tr>
                                            <tr>
                                                <td width="40%"><img src="./images/page1.png" alt="内地代理人" /></td>
                                                <td width="60%"><img src="./images/page2.png" alt="基金管理人" /></td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    {/* 横幅部分 */}
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td className="display-banner">
                                                    <table cellSpacing="0" cellPadding="0">
                                                        <tbody>
                                                            <tr>
                                                                <td><img alt="" src="./images/banner-bg-fund-detail.jpg" width="320" height="89" /></td>
                                                                <td className="extend-bg"><img alt="" src="./images/banner-bg-repeat.jpg" width="1" height="89" /></td>
                                                                <td>
                                                                    <div className="banner-title">
                                                                        <img alt="" src="./images/banner-bg-r.jpg" width="280" height="89" />
                                                                        <h1 className="extendedWidth">中银香港盈荟系列－中银香港 全天候中国高息债券基金</h1>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    <div className="content">
                                        {/* 风险提示 */}
                                        <div className="greyBox">
                                            <ul className="roundBullet marginT10">
                                                <li>本基金为经中国证监会注册的香港互认基金。</li>
                                                <li>本基金依照香港法律设立，其投资运作、信息披露等规范适用香港法律法规及香港证监会的有关规定。</li>
                                                <li>中国证监会对本基金的注册不代表中国证监会对本基金的风险和收益作出实质性判断、推荐或保证。</li>
                                                <li>本基金不保证收益。投资者可能损失全部投资本金。</li>
                                                <li>投资涉及风险，本基金涉及重大风险包括但不限于市场风险、有关人民币的风险、信贷风险、与高收益及未被评级证券相关的风险、有限投资项目的风险、内地市场/新兴市场风险、集中风险、估值风险、流通性风险、有关RQFII基金的风险、利率风险、货币风险/对冲风险、与对冲及对冲类别相关的风险、衍生工具风险等。另外，本基金作为香港互认基金，涉及境外投资风险、暂停内地销售的风险、取消基金互认、终止内地销售的风险、销售安排差异的风险、适用境外法的相关风险、内地销售机构、内地代理人或内地登记结算机构的操作风险、技术风险、跨境数据传输和跨境资金交收的风险及税收风险等。</li>
                                                <li>投资者不应仅就本网页披露的基本信息作出投资决定。投资者在作出任何投资决定前，应详细阅读本基金的招募说明书、信托契约等基金文件，以了解本基金的详情和风险。</li>
                                                <li>过往业绩并非预示日后的业绩表现。</li>
                                                <li>香港证监会的认可不等同于对本基金作出推介或背书，亦不是对本基金的商业利弊或其表现作出保证。更不代表本基金适合所有投资者，或保证本基金适合任何个别投资者或任何类别的投资者。</li>
                                            </ul>
                                        </div>

                                        {/* 投资目标 */}
                                        <h2 className="marginT20">投资目标</h2>
                                        <p>本基金的投资目标是通过主要投资于以人民币或其他货币计价的固定收益及债务证券(简称"债务证券"), 提供长远资本增值及人民币收益。本基金亦可能投资于人民币存款。为实现投资目标, 本基金将直接投资于一个由中国境外发行及买卖的债务证券组成的管理资产组合。</p>

                                        {/* 资料概览 */}
                                        <h2 className="marginT30 greyLine">资料概览</h2>
                                        <table className="alternative-bg2 records">
                                            <tbody>
                                                <tr>
                                                    <td className="greytxt width20">基金代码</td>
                                                    <td colSpan="5">968012</td>
                                                </tr>
                                                <tr className="odd">
                                                    <td className="greytxt">基金管理人</td>
                                                    <td colSpan="5">中银香港资产管理有限公司</td>
                                                </tr>
                                                <tr>
                                                    <td className="greytxt">内地代理人</td>
                                                    <td colSpan="5">中银基金管理有限公司</td>
                                                </tr>
                                                <tr className="odd">
                                                    <td className="greytxt">基金类别</td>
                                                    <td colSpan="5">债券型基金</td>
                                                </tr>
                                                <tr>
                                                    <td className="greytxt">成立日期</td>
                                                    <td colSpan="5">2013年3月22日</td>
                                                </tr>
                                                <tr className="odd">
                                                    <td className="greytxt">基础货币</td>
                                                    <td colSpan="5">人民币</td>
                                                </tr>
                                                <tr>
                                                    <td className="greytxt">交易频率</td>
                                                    <td colSpan="5">每交易日#</td>
                                                </tr>
                                                <tr className="odd">
                                                    <td className="greytxt">在内地发售的份额类别</td>
                                                    <td colSpan="5">A1 (人民币) 类</td>
                                                </tr>
                                                <tr>
                                                    <td className="greytxt">收益分配政策</td>
                                                    <td colSpan="5">基金管理人拟于每季(即三月、六月、九月及十二月)宣布及分配收益, 或由基金管理人酌情决定</td>
                                                </tr>
                                                <tr className="odd">
                                                    <td className="greytxt">申购费*</td>
                                                    <td colSpan="5">1%</td>
                                                </tr>
                                                <tr>
                                                    <td className="greytxt">赎回费*</td>
                                                    <td colSpan="5">无</td>
                                                </tr>
                                                <tr className="odd">
                                                    <td className="greytxt">管理费**</td>
                                                    <td colSpan="5">每年最高为 2.5% (现行费率1.25%)</td>
                                                </tr>
                                                <tr>
                                                    <td className="greytxt">受托人费用**</td>
                                                    <td colSpan="5">每年最高为0.125%</td>
                                                </tr>
                                                <tr className="odd">
                                                    <td className="greytxt">保管人费用**</td>
                                                    <td colSpan="5">每年最高为0.3%</td>
                                                </tr>
                                                <tr>
                                                    <td className="greytxt">业绩表现费</td>
                                                    <td colSpan="5">没有</td>
                                                </tr>
                                                <tr className="odd">
                                                    <td className="greytxt">风险等级 <sup>◆</sup></td>
                                                    <td colSpan="5">【R5 高风险】</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <div className="table-note">
                                            <p>* 请参阅本基金的招募说明书及信托契约以了解详情。</p>
                                            <p>** 该等费用及收费可通过向基金份额持有人发出最少一个月事先通知调升至准许的最高收费。请参阅招募说明书及信托契约以了解详情。</p>
                                            <p>#本基金内地销售的交易日是指内地销售机构接受办理内地投资者申购、转换等业务的日期, 具体为上海证券交易所和深圳证券交易所(以下合称"沪深交易所")同时开放交易的香港交易日。</p>
                                            <p><sup>◆</sup>此网页所显示的风险等级由内地代理人进行评级及提供，基金管理人未对该等资料进行独立核证。相关风险评级结果是内地代理人根据投资者适当性法律法规对本基金进行风险评价的结果，未必与基金管理人所提供的风险等级资料一致。基金管理人并不就本处风险等级资料的任何错误、遗漏、不准确、不充分或未及时更新承担任何责任。相关风险等级供投资者参考，内地销售机构亦将根据法规要求对投资者类别、风险承受能力和本基金的风险等级进行划分，并提出适当性匹配意见，请投资者根据自身风险承受能力购买相匹配的风险等级产品。投资者不应只根据本处风险等级资料而作出任何投资决定。若对上述所提供的风险等级资料有任何疑问，请咨询独立财务及专业人士的意见。</p>
                                        </div>

                                        {/* 最新份额净值 */}
                                        <h2>最新份额净值</h2>
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td width="20%">日期</td>
                                                    <td width="20%">货币</td>
                                                    <td colSpan="4">份额净值</td>
                                                </tr>
                                                {this.state.fundvaluelist}
                                            </tbody>
                                        </table>

                                        {/* 基金年度的过往表现 */}
                                        <h2>基金年度的过往表现</h2>
                                        <table className="records headingAlignCenter alternative-bg" id="past_authorisedrmb">
                                            <tbody>
                                                <tr>
                                                    <td width="20%"></td>
                                                    {this.state.performanceTime}
                                                </tr>
                                                <tr>
                                                    <td>A1 (人民币) 类</td>
                                                    {this.state.performanceValue}
                                                </tr>
                                            </tbody>
                                        </table>
                                        <div className="table-note">
                                            <p>投资涉及风险，过往业绩并非预示日后的业绩表现。投资者未必能收回全额投资本金。基金业绩表现以历年末的资产净值作为比较基础，收益会滚存再作投资。上述数据显示A1(人民币) 类总值在相关年份的升跌幅度。业绩表现以人民币计算，其中反映出基金的持续费用，但不包括基金可能向投资者收取的申购及赎回费。如某个年份没有显示相关业绩表现，即表示当年没有足够数据用于提供业绩表现。<br />
                                                基金成立日：2013年3月22日<br />
                                                A1(人民币)类别成立日：2013年3月22日</p>
                                        </div>

                                        {/* 下载部分 */}
                                        <FileListComponent
                                            items={this.state.downloads}
                                            title="下载"
                                            type="downloads"
                                            showDate={false}  // 下载通常不显示日期
                                            defaultCount={5}
                                            onItemClick={(item, index) => console.log('点击下载:', item)}
                                            onViewMore={(type) => console.log('查看更多:', type)}
                                        />

                                        {/* 基金文件部分 */}
                                        <FileListComponent
                                            items={this.state.fundFiles}
                                            title="基金文件"
                                            type="files"
                                            defaultCount={5}
                                            dateFormat="slice"  // 只显示年月日
                                            onItemClick={(item, index) => {
                                                // 可以在这里添加点击统计等逻辑
                                                // this.trackFileClick(item, 'files');
                                            }}
                                        />

                                        {/* 基金公告部分 */}
                                        <FileListComponent
                                            items={this.state.fundNotices}
                                            title="基金公告"
                                            type="notices"
                                            defaultCount={5}
                                            onViewMore={(type) => {
                                                // 查看更多时的回调，可以用于统计
                                                // this.trackViewMore(type);
                                            }}
                                        />

                                        {/* 重要事项 */}
                                        <h2 className="marginT20">重要事項</h2>
                                        <div>
                                            <div className="imptNote233">
                                                {/* 修改这里：销售机构动态渲染 */}
                                                {this.renderSaleOrgs() ? (
                                                    <p>投资者应当通过由本基金的内地代理人和/或基金管理人或内地代理人委托的其他具有基金销售业务资格的销售机构申购和赎回本基金。现时，本基金的内地销售机构包括{this.renderSaleOrgs()}。基金管理人或内地代理人可不时变更或增减内地销售机构，并予以公示。</p>
                                                ) : (
                                                    <p>投资者应当通过由本基金的内地代理人和/或基金管理人或内地代理人委托的其他具有基金销售业务资格的销售机构申购和赎回本基金。现时，本基金的内地销售机构包括中国银行股份有限公司、上海基煜基金销售有限公司、珠海盈米基金销售有限公司、上海好买基金销售有限公司、北京汇成基金销售有限公司、中银基金管理有限公司直销柜台和中信建投证券股份有限公司。基金管理人或内地代理人可不时变更或增减内地销售机构，并予以公示。</p>
                                                )}
                                                <p>本基金内地代理人为中银基金管理有限公司。本基金内地代理人接受基金管理人的代理委托，并不表明本基金内地代理人对代理本基金的价值和收益作出实质性判断或保证，也不表明投资于本基金没有风险。本基金内地代理人对本基金的财政稳健状况或任何在本基金招募说明书中作出的声明或发表的意见，不承担任何责任。</p>
                                                <p>基金文件的复印件置备于本基金招募说明书"各方名录"一节所列示的基金管理人和内地代理人的地址以及内地销售机构的营业场所，在任何一日(星期六、星期日及公众假期除外)正常办公时间内供投资者免费查阅，投资者也可在支付合理工本费后索取复印件。上述资料并不构成进行或变现投资或进行任何其他交易的要约或建议，亦不应用作任何投资决策或其他决策的依据。任何投资决策应当根据投资者个人/个别需求而寻求适当且专业的建议。</p>
                                                <p>本网站所载的内容由中银香港资产管理有限公司制作，并由中银基金管理有限公司刊发，并未经中国证监会及香港证监会审阅。</p>
                                            </div>
                                        </div>

                                        <p className="tdR marginT20">
                                            <img alt="回到顶部" src="./images/cn/btn-backToTop.jpg" onClick={this.toTheTop} />
                                        </p>
                                    </div>
                                </td>
                                <td width="12%">&nbsp;</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                {/* 页脚 */}
                <p className="footer">
                    <table>
                        <tbody>
                            <tr>
                                <td className="copyright">
                                    <div>&copy; 2023 中银基金管理有限公司及中银香港资产管理有限公司。版权所有。</div>
                                </td>
                                <td width="50%">
                                    <table>
                                        <tbody>
                                            <tr height="10px">
                                                <td width="50%"><font size="2">内地代理人：</font></td>
                                                <td width="50%"><font size="2">基金管理人：</font></td>
                                            </tr>
                                            <tr>
                                                <td width="50%"><img src="./images/page1.png" alt="内地代理人" /></td>
                                                <td width="50%"><img src="./images/page2.png" alt="基金管理人" /></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </p>
            </div>
        );
    }
}